import { createStyles } from 'antd-style';

import { LoadingAnimation } from 'components/loading/LoadingAnimation';

const useStyles = createStyles(({ token }) => ({
  loadingOverlay: {
    backgroundColor: token.colorBgElevated,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '600px',
    width: '1200px',
    backdropFilter: 'blur(4px)',
  },
  title: {
    color: token.colorPrimary,
    fontSize: token.fontSizeLG,
    fontWeight: token.fontWeightStrong,
  },
  subtitle: {
    color: token.colorText,
    fontSize: token.fontSizeSM,
  },
}));
const LoadingOverlay = () => {
  const { styles } = useStyles();
  return (
    <div className={styles.loadingOverlay}>
      <div className="flex flex-col items-center gap-4">
        {/* Spinning circle animation */}
        <LoadingAnimation />

        {/* Loading text */}
        <div className="flex flex-col items-center">
          <span className={styles.title}>Loading Data</span>
          <span className={styles.subtitle}>Please wait...</span>
        </div>
      </div>
    </div>
  );
};

export { LoadingOverlay };
